import { Icon } from "@iconify/react";
import React from "react";

type ChipProps = {
  label: string;
  selected?: boolean;
  onClick?: () => void;
  ariaLabel?: string;
  icon?: string;
};

export default function Chip({
  label,
  selected = false,
  onClick,
  ariaLabel,
  icon,
}: ChipProps) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      aria-label={ariaLabel ?? label}
      onClick={onClick}
      className={[
        "inline-flex items-center justify-center cursor-pointer",
        "px-4 py-2 text-sm font-medium",
        "rounded-lg border transition-colors duration-150 ease-in-out",
        "shadow-sm", // subtle lift like your image
        selected
          ? "main-bg-color border-[#021e35] text-color" // selected style
          : "bg-white border-gray-200 text-gray-700 hover:border-gray-300",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300 focus-visible:ring-offset-1",
      ].join(" ")}
    >
      {icon && <Icon icon={icon} className="w-4 h-4 mr-2" />}
      {label}
    </button>
  );
}
